import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string().required().email("Invalid email address"),
  role: yup.string(),
});

export default schema;
